import moment from "moment"
import React from "react"
import { Tab, Table, Tabs } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import Gallery from "react-grid-gallery"
import { ChargeCalculationType, ChargeTimeType, fillingZeroUtility, fineractDateToStr,
  formatCurrency, getChargeAmount } from "../../lib/utils"
import DisplayTransactionModalScreen from "./DisplayTransactionModal"
import EditTransactionModalScreen from "./EditTransactionModal"

class AllDetails extends React.Component {

  state = {
    transactionId: null,
    transactionAmount: null,
    transactionDate: null,
    showEdit: false,

    transactionDetails: null,
    showTransaction: false,
  }

  updateOrDeleteTransaction = (transactionId, transactionAmount, transactionDate) => {

    const htmlDate = transactionDate.length 
      ? `${transactionDate[0]}-${ 
        fillingZeroUtility(transactionDate[1]) }-${ fillingZeroUtility(transactionDate[2]) }` : null

    this.setState({
      transactionId: transactionId,
      transactionAmount: transactionAmount,
      transactionDate: htmlDate,
      showEdit: true
    })
  }

  displayTransaction = transaction => this.setState({
    transactionDetails: transaction,
    showTransaction: true,
  })

  renderAccountDetails = ({ transactionProcessingStrategyName, currency, netDisbursalAmount,
    numberOfRepayments, repaymentEvery, repaymentFrequencyType, timeline, summary }) => (
    <Table responsive striped bordered condensed hover>

      <tbody>

        <tr>
          <td>Repayment strategy</td>
          <td>{ transactionProcessingStrategyName }</td>
        </tr>

        <tr>
          <td>Currency</td>
          <td>{ currency.displayLabel }</td>
        </tr>

        <tr>
          <td>Net amount</td>
          <td>{ netDisbursalAmount }</td>
        </tr>

        <tr>
          <td>Repayments</td>
          <td>
            { fillingZeroUtility(numberOfRepayments) } every&nbsp;
            { fillingZeroUtility(repaymentEvery) }&nbsp;
            { repaymentFrequencyType.value }
          </td>
        </tr>

        <tr>
          <td>Approved on</td>
          <td>{ timeline ? fineractDateToStr(timeline.approvedOnDate) : null }</td>
        </tr>

        <tr>
          <td>Actual disbursement date</td>
          <td>{ timeline ? fineractDateToStr(timeline.actualDisbursementDate) : null }</td>
        </tr>

        <tr>
          <td>Expected maturity date</td>
          <td>{ timeline ? fineractDateToStr(timeline.expectedMaturityDate) : null }</td>
        </tr>

        <tr>
          <td>Principal disbursed</td>
          <td>{ summary ? summary.principalDisbursed : null }</td>
        </tr>

        <tr>
          <td>Principal outstanding</td>
          <td>{ summary ? summary.principalOutstanding : null }</td>
        </tr>

        <tr>
          <td>Total expected cost of loan</td>
          <td>{ summary ? summary.totalExpectedCostOfLoan : null }</td>
        </tr>

        <tr>
          <td>Total expected repayment</td>
          <td>{ summary ? summary.totalExpectedRepayment : null }</td>
        </tr>

        <tr>
          <td>Total repayment</td>
          <td>{ summary ? summary.totalRepayment : null }</td>
        </tr>

      </tbody>
    </Table>
  )

  renderRepayments = loanDetails => {

    const { repaymentSchedule: { periods } } = loanDetails,
    periodsHtml = []

    for (let i = 0; i < periods.length; i++) {

      const { daysInPeriod, dueDate, complete, obligationsMetOnDate, principalDue,
        principalLoanBalanceOutstanding, feeChargesDue, totalDueForPeriod, totalPaidForPeriod,
        totalPaidInAdvanceForPeriod, totalPaidLateForPeriod, totalOutstandingForPeriod } = periods[i]

      periodsHtml.push(<tr key={ `period${i}` }>
        <td className="align-center">{ i ? i : '' }</td>
        <td className="align-center">{ i ? daysInPeriod : '' }</td>
        <td>
          { fineractDateToStr(dueDate) } &nbsp;
          { complete ? <span className="checked-due-date">
            <FontAwesome name='check' className="green" /></span> : ''
          }
        </td>
        <td>{ i ? fineractDateToStr(obligationsMetOnDate) : '' }</td>
        <td>{ i ? principalDue : '' }</td>
        <td>{ principalLoanBalanceOutstanding }</td>
        <td>{ feeChargesDue }</td>
        <td>{ totalDueForPeriod }</td>
        <td>{ totalPaidForPeriod }</td>
        <td>{ i ? totalPaidInAdvanceForPeriod : '' }</td>
        <td>{ i ? totalPaidLateForPeriod : '' }</td>
        <td>{ i ? totalOutstandingForPeriod : '' }</td>
      </tr>)
    }

    return (
      <Table responsive striped condensed hover>

        <thead>
          <tr>
            <th className='align-center'>#</th>
            <th className='align-center'>Days in period</th>
            <th>Due date</th>
            <th>Paid Date</th>
            <th>Principal Due</th>
            <th>Balance of Loan</th>
            <th>Fees</th>
            <th>Due</th>
            <th>Paid</th>
            <th>In Advance</th>
            <th>Late</th>
            <th>Outstanding</th>
          </tr>
        </thead>

        <tbody>{ periodsHtml }</tbody>

      </Table>
    )
  }

  renderOperations = (type, transactionId, transactionAmount, transactionDate, manuallyReversed) => {

    if(type !== 'Repayment' || manuallyReversed) return null
    return (
      <span>
        <span className="cursor-pointer" 
          onClick={e => {
            e.stopPropagation()
            this.updateOrDeleteTransaction(transactionId, transactionAmount, transactionDate)
          }}>
          <FontAwesome name='pencil' title='Update' />
        </span>
        &nbsp; &nbsp;
        <span className='red cursor-pointer'
          onClick={e => {
            e.stopPropagation()
            this.updateOrDeleteTransaction(transactionId, 0, transactionDate)
          }}>
          <FontAwesome name='trash' title='Delete' />
        </span>
      </span>
    )
  }

  renderTransactions = loanDetails => {

    const { transactions } = loanDetails
    if (!transactions) return null
    transactions.sort((a, b) => b.id - a.id)

    let transactionsHtml = []
    for (let i = 0; i < transactions.length; i++) {

      const item = transactions[i]
      const { id: itemId, date, type, amount, principalPortion, outstandingLoanBalance,
        manuallyReversed } = item
  
      const className = manuallyReversed ? 'manuallyReversed' : ''

      transactionsHtml.push(<tr key={ `transaction${i}` } className="cursor-pointer"
        onClick={() => this.displayTransaction(item)}>

        <td className={`align-center ${ className }`}>
          { itemId }
        </td>

        <td className={ className }>
          { fineractDateToStr(date) }
        </td>

        <td className={ className }>
          { type.value }
        </td>

        <td className={ className }>
          { amount }
        </td>

        <td className={ className }>
          { principalPortion }
        </td>

        <td className={ className }>
          { outstandingLoanBalance }
        </td>

        <td className={`align-center ${ className }`}>
          { this.renderOperations(type.value, itemId, amount, date, manuallyReversed) }
        </td>

      </tr>)
    }

    return (
      <Table responsive striped condensed hover>

        <thead>
          <tr>
            <th className='align-center'>#</th>
            <th>Transaction Date</th>
            <th>Transaction Type</th>
            <th>Amount</th>
            <th>Principal</th>
            <th>Loan Balance</th>
            <th className='align-center'>Operations</th>
          </tr>
        </thead>

        <tbody>{ transactionsHtml }</tbody>

      </Table>
    )
  }

  renderCharges = charges => {

    const chargesHtml = charges.map((item, index) => {

      const { name, penalty, amount, amountPaid, amountOutstanding, chargeTimeType: { value: chargeTimeType },
        chargeCalculationType: { value: chargeCalculationType }, dueDate } = item

      return <tr key={ `charge-${ index }` }>
        <td>{ name }</td>
        <td>{ penalty ? 'penalty' : 'Fee' }</td>
        <td>{ chargeTimeType }</td>
        <td>{ chargeCalculationType }</td>
        <td>{ dueDate ? fineractDateToStr(dueDate) : null }</td>
        <td>{ formatCurrency(amount) }</td>
        <td>{ formatCurrency(amountPaid) }</td>
        <td>{ formatCurrency(amountOutstanding) }</td>
      </tr>
    })

    return (
      <Table responsive striped condensed hover>

        <thead>
          <tr>
            <th>Name</th>
            <th>Fee/Penalty</th>
            <th>Payment due at</th>
            <th>Calculation Type</th>
            <th>Due date</th>
            <th>Due</th>
            <th>Paid</th>
            <th>Outstanding</th>
          </tr>
        </thead>

        <tbody>{ chargesHtml }</tbody>

      </Table>
    )
  }

  renderLoanCharges = loanCharges => {

    const chargesHtml = loanCharges.map((item, index) => {

      const { name, amount, chargeTimeType, chargeCalculationType, dueDate, currencyCode } = item

      return <tr key={ `charge-${ index }` }>
        <td>{ name }</td>
        <td>{ ChargeTimeType[chargeTimeType] }</td>
        <td>{ ChargeCalculationType[chargeCalculationType] }</td>
        <td>{ dueDate ? moment(dueDate).format('ll') : null }</td>
        <td>{ getChargeAmount({ amount, chargeCalculationType, currencyCode }) }</td>
      </tr>
    })

    return (
      <Table responsive striped condensed hover>

        <thead>
          <tr>
            <th>Name</th>
            <th>Payment due at</th>
            <th>Calculation Type</th>
            <th>Due Date</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody>{ chargesHtml }</tbody>

      </Table>
    )
  }

  render() {

    const { loanDetails, reloadDetails, detailsRunning, isAuthorized, loanImages,
      loanId, disburseDate, loanCharges } = this.props,

    { showEdit, transactionId, transactionAmount, transactionDate,
      showTransaction, transactionDetails, } = this.state,

    charges = loanDetails ? loanDetails.charges : null,

    chargesHtml = (charges && charges.length)
      ? this.renderCharges(charges)
      : (loanCharges && loanCharges.length)
        ? this.renderLoanCharges(loanCharges)
        : null

    return (
      <div className="mt-20">

        { isAuthorized &&
          <div className='hot-color mb-10'>
            { detailsRunning 
            ? <span>Running ..</span>
            : <span className='cursor-pointer' onClick={ reloadDetails }>
                <FontAwesome name='refresh' /> Reload details
              </span>
            }
          </div>
        }

        <Tabs defaultActiveKey={ isAuthorized ? 2 : 5 } id='uncontrolled-loans-tab'>

          <Tab eventKey={1} title='Account Detail'>
            { loanDetails ? this.renderAccountDetails(loanDetails) : null }
          </Tab>

          { isAuthorized &&
          <Tab eventKey={2} title='Repayment Schedule'>
            { loanDetails ? this.renderRepayments(loanDetails) : null }
          </Tab>
          }

          { isAuthorized &&
          <Tab eventKey={3} title="Transactions">
            { loanDetails ? this.renderTransactions(loanDetails) : null }
          </Tab>
          }

          { chargesHtml &&
          <Tab eventKey={4} title="Charges">
            { chargesHtml }
          </Tab>
          }

          <Tab eventKey={5} title="Loan Documents">

            <div className="gallery-div">
              <Gallery
                rowHeight={200}
                images={ loanImages }
                enableImageSelection={ false }
                showLightboxThumbnails={ true }
              />
            </div>
          </Tab>
        </Tabs>

        { showEdit &&
        <EditTransactionModalScreen
          loanId={ loanId }
          disburseDate={ disburseDate }
          transactionId={ transactionId }
          transactionAmount={ transactionAmount }
          transactionDate={ transactionDate }
          showEdit={ showEdit }
          handleClose={() => this.setState({ showEdit: false })}
          reloadDetails={ reloadDetails }
        />
        }

        { showTransaction &&
        <DisplayTransactionModalScreen
          transaction={ transactionDetails }
          showTransaction={ showTransaction }
          handleCloseTransation={() => this.setState({ showTransaction: false })}
          updateOrDeleteAction={(id, amount, date) => {
            this.setState({ showTransaction: false })
            this.updateOrDeleteTransaction(id, amount, date)
          }}
        />
        }
      </div>
    )
  }
}

export default AllDetails



// WEBPACK FOOTER //
// ./src/components/Loans/AllDetails.js